import { useTranslation } from 'react-i18next';
import { LOCALES } from '@jetopolis/i18n';
import { changeLocale } from '../../i18n';

/**
 * Переключатель языка. Все 25 локалей в одном списке с самоназваниями:
 * искать "Русский" в списке, подписанном по-английски, игрок не должен.
 */
export function LocalePicker({ compact = false }: { compact?: boolean }) {
  const { t, i18n } = useTranslation();
  return (
    <label className="flex items-center gap-2">
      {!compact && (
        <span className="text-[10px] uppercase tracking-wider text-dim">
          {t('common.label.language')}
        </span>
      )}
      <select
        value={i18n.language}
        aria-label={t('common.label.language')}
        onChange={(e) => {
          void changeLocale(e.target.value);
        }}
        className="min-h-[var(--spacing-touch)] rounded-[6px] border border-line2 bg-panel2 px-2 text-[12px] text-txt outline-none focus:border-amber"
      >
        {LOCALES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.nativeName}
          </option>
        ))}
      </select>
    </label>
  );
}
